import { useCallback, useEffect, useRef, useState } from 'react'

/** Keeps a confirmed success visible briefly. Cancels the presentation wait on unmount. */
export function usePublishingCompletion() {
  const [publicationComplete, setComplete] = useState(false)
  const mounted = useRef(true)
  const pending = useRef<{ timer: ReturnType<typeof setTimeout>; resolve: (active: boolean) => void } | null>(null)

  const resetCompletion = useCallback(() => {
    if (mounted.current) setComplete(false)
  }, [])

  const showCompletion = useCallback(() => {
    if (!mounted.current) return Promise.resolve(false)
    if (pending.current) return Promise.resolve(false)
    setComplete(true)
    return new Promise<boolean>((resolve) => {
      const timer = setTimeout(() => {
        pending.current = null
        resolve(mounted.current)
      }, 600)
      pending.current = { timer, resolve }
    })
  }, [])

  useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
      if (pending.current) {
        clearTimeout(pending.current.timer)
        pending.current.resolve(false)
        pending.current = null
      }
    }
  }, [])

  return { publicationComplete, resetCompletion, showCompletion }
}
